// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SEI_CustTable"
const create = function () {
  return {
    content_type: "muji"
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [{
    key: "id",
    label: "编号",
    sortable: true,
    thStyle: {
      width: "60px"
    }
  },
  {
    key: "AccountNum",
    label: "客户帐户",
    sortable: true
  },
  {
    key: "SEI_Name",
    label: "客户名称",
    sortable: true,
    thStyle: {
      width: "15rem"
    }
  },
  {
    key: "SaleAreaid",
    label: "默认销售公司",
    sortable: true
  },
  {
    key: "CustGroup",
    label: "客户组",
    sortable: true
  },
  {
    key: "CustClassificationId",
    label: "客户分类组",
    sortable: true
  },
  {
    key: "SEI_BigCustomerNumber",
    label: "TOP客户组",
    sortable: true
  },
  {
    key: "Currency",
    label: "币种",
    sortable: true
  },
  {
    key: "CreditMax",
    label: "信用额度",
    sortable: true,
    type: "number"
  },
  {
    key: "dispUsedCreditAmount",
    label: "已用信用额度",
    sortable: true,
    type: "number"
  },
  {
    key: "TaxGroup",
    label: "销售税组",
    sortable: true
  },
  {
    key: "InclTax",
    label: "价格包括销售税",
    sortable: true
  },
  {
    key: "TEC_TaxCustAddress",
    label: "客户地址",
    sortable: true,
    thStyle: {
      width: "20rem"
    }
  },
  {
    key: "PaymDayId",
    label: "付款日",
    sortable: true
  },
  {
    key: "PaymTermId",
    label: "付款期限",
    sortable: true
  },
  {
    key: "SegmentId",
    label: "细分市场",
    sortable: true
  },
  {
    key: "SubsegmentId",
    label: "子细分市场",
    sortable: true
  },
  {
    key: "PartyCountry",
    label: "国家/地区",
    sortable: true
  },
  {
    key: "MainContactWorker",
    label: "负责员工",
    sortable: true
  },
  {
    key: "modifiedDateTime",
    label: "修改日期和时间",
    type: "datetime"
  }
  ],
  user_fields: [{
    key: "id",
    label: "编号",
    sortable: true,
    thStyle: {
      width: "60px"
    }
  },
  {
    key: "department",
    label: "部门",
    sortable: true
  },
  {
    key: "username",
    label: "用户名",
    sortable: true
  },
  {
    key: "realname",
    label: "姓名",
    sortable: true
  },
  {
    key: "email",
    label: "邮箱",
    sortable: true
  },
  {
    key: "is_valid",
    label: "启用",
    type: "boolean"
  },
  {
    key: "isInternal",
    label: "内部账号",
    type: "boolean"
  },
  {
    key: "isDomainUser",
    label: "域用户",
    type: "boolean"
  },
  {
    key: "is_Include_All",
    label: "绑定所有客户",
    type: "boolean"
  }
  ],
  relation_fileds: [{
    key: "id",
    label: "编号"
  },
  {
    key: "user_id",
    label: "用户id"
  },
  {
    key: "AccountNum",
    label: "客户编号"
  }
  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  async bind_all(userIds, state) {
    let query_settings = []
    _.each(userIds, t => {
      let _p = new FormData()
      _p.append("id", t.id)
      _p.append("username", t.username)
      _p.append("is_Include_All", state)
      _p.append("realname", t.realname == null ? "" : t.realname)
      _p.append("email", t.email == null ? "" : t.email)
      _p.append("department", t.department == null ? "" : t.department)
      _p.append("description", t.description == null ? "" : t.description)
      _p.append("is_valid", t.is_valid)
      _p.append("isDomainUser", t.isDomainUser)
      _p.append("isInternal", t.isInternal)

      query_settings.push({
        url: apiPath.admin.update_user,
        parameters: _p,
        method: "post"
      })
    })

    let result = await api.query_all_async(query_settings)
    if (result && result[0].result && result[0].result.data) {
      return result[0].result.data
    } else {
      return null
    }
  },
  //追加
  async pasteUserCustomers(users, Customers) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "paste_user_customer_relation", {}, {}
    )
    let _actions = []
    _.each(users, t => {
      _.each(Customers, y => {
        _actions.push(
          code_biz_data
            .execAction({
              params: {
                sys_user_id: t,
                AccountNum: y.AccountNum
              },
              fields: []
            })
            .action({})
        )
      })
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  //同步客户(删除原有客户)
  async syncUserCustomers(users, customers) {
    const delete_biz_data = new biz_data_helper.base_entity_helper(
      "delete_CustUserRelation", {}, {}
    )
    const sync_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_CustUserRelation", {}, {}
    )
    let _actions = []
    _.each(users, t => {
      _actions.push(
        delete_biz_data
          .execAction({
            params: {
              sys_user_id: t,
            },
            fields: []
          })
          .action({})
      )
      _.each(customers, y => {
        let _data = {}
        _data.user_id = t
        _data.AccountNum = y.AccountNum
        _actions.push(
          sync_biz_data
            .insertAction({
              params: _data,
              fields: ["id"]
            })
            .action({})
        )
      })
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  //保存
  async saveData(data, dataList) {
    const relation_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_CustUserRelation",
      create,
      descriptor
    )
    const delete_biz_data = new biz_data_helper.base_entity_helper(
      "delete_CustUserRelation", {}, {}
    )
    let _actions = []
    // 删除原有的绑定
    _actions.push(
      delete_biz_data
        .execAction({
          params: {
            sys_user_id: data.id
          },
          fields: []
        })
        .action({})
    )
    // //新增客户员工绑定
    if (dataList.length > 0) {
      _.each(dataList, t => {
        let _data = {}
        _data.user_id = data.id
        _data.AccountNum = t.AccountNum
        _actions.push(
          relation_biz_data
            .insertAction({
              params: _data,
              fields: ["id"]
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  //获取用户信息
  async getUserData() {
    let result = await api.query_async({
      url: apiPath.admin.get_user_list,
      parameters: null,
      method: "get"
    })
    ///此处可以编写逻辑处理
    if (
      result &&
      result[0].result.data &&
      result[0].result.data.Result.length > 0
    ) {
      return result[0].result.data.Result
    } else {
      return null
    }
  },
  //获取关系
  async getRelation(_params) {
    const relation_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_CustUserRelation",
      create,
      descriptor
    )
    let result = await relation_biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.relation_fileds, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getUserInfo(_params) {
    const user_biz_data = new biz_data_helper.base_entity_helper(
      "get_userInfo", {}, {}
    )
    let result = await user_biz_data
      .execAction({
        params: _params,
        fields: ["id"]
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get
  async getData(_params) {
    let _actions = []
    let _new = _.cloneDeep(_params)
    delete _new.id

    //获取信用额度
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_customer_credit", {}, {}
    )

    _actions.push(
      code_biz_data
        .execAction({
          params: {},
          fields: ["AccountNum", "CreditMax", "Temp_CreditMax"]
        })
        .action({})
    )
    _actions.push(
      biz_data
        .selectAction({
          params: _params,
          fields: _.map(fields.default, "key")
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions[1].Result.Data.length > 0
    ) {
      ///计算客户信用额度，非平台信用额度+平台设置的信用额度(仅已审核)+平台临时信用额度(仅已审核)
      _.each(result.data.BatchResult.Actions[1].Result.Data[0], t => {
        let _ct = _.find(result.data.BatchResult.Actions[0].Result.Data[0], {
          AccountNum: t.AccountNum
        })
        if (_ct) {
          t.CreditMax = _ct.CreditMax + _ct.Temp_CreditMax
        } else {
          t.CreditMax = 0
        }
      })

      return result.data.BatchResult.Actions[1].Result.Data
    } else {
      return null
    }
  }
}
export {
  fields,
  methods,
  dataForm,
  rules,
  biz_data
}
